import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Style } from '@/components/style';

const { primaryColor } = new Style().getUiConfig();

function Header({ children }) {
  return (
    <div
      className="w-100 sticky-top d-flex shadow-title"
      style={{ background: '#fff', zIndex: 999 }}
    >
      <div
        className="w-100 d-flex align-self-center  fw-bold fs-4"
        style={{ height: '44px', color: primaryColor }}
      >
        <div className="d-flex w-100 align-items-center justify-content-center">
          {children}
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {};

export default Header;
